export default __webpack_public_path__ + "fonts/iot_2.f262afa60f0da9b562672c203034fd31.png";